module.exports = __webpack_public_path__ + "assets/img/nodata1.afe31394.png";